document.addEventListener('DOMContentLoaded', function () {
  initMindifyChrome(document);
  initMindifyFaq(document);
  initMindifyAppTabs(document);
  initMindifyHoverVideos(document);
  initMindifySmartVideos(document);
  initMindifyDeferredVideos(document);
  initMindifyHomeCaseShowcases(document);
  initMindifyContactForms(document);
  initMindifyCookieBanner();
  initMindifyAos();

  window.openVideoModal = function (caseId) {
    var modal = document.getElementById('videoModal');
    if (!modal) return;
    var data = window.MINDIFY_CASE_VIDEOS && window.MINDIFY_CASE_VIDEOS[caseId];
    var holder = modal.querySelector('.video-modal-content .aspect-video') || modal.querySelector('.video-modal-content');
    if (data && holder) {
      var embedUrl = getMindifyEmbedUrl(data);
      if (embedUrl) {
        holder.innerHTML = '<iframe src="' + embedUrl + '" allow="autoplay; encrypted-media; picture-in-picture" allowfullscreen class="w-full h-full"></iframe>';
      } else if (data.videoUrl) {
        holder.innerHTML = '<video class="w-full h-full object-cover" controls autoplay muted playsinline preload="metadata" poster="' + escapeMindifyAttr(data.posterUrl || '') + '" src="' + escapeMindifyAttr(data.videoUrl) + '"></video>';
        var modalVideo = holder.querySelector('video');
        if (modalVideo) {
          modalVideo.muted = true;
          var playPromise = modalVideo.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
          modalVideo.addEventListener('canplay', function () {
            var replayPromise = modalVideo.play();
            if (replayPromise && typeof replayPromise.catch === 'function') replayPromise.catch(function () {});
          }, { once: true });
        }
      } else {
        holder.innerHTML = '<div class="flex items-center justify-center h-full text-white"><p class="text-lg opacity-70">Add a video in the Shopify editor.</p></div>';
      }
    } else if (holder) {
      holder.innerHTML = '<div class="flex items-center justify-center h-full text-white"><p class="text-lg opacity-70">Add a video in the Shopify editor.</p></div>';
    }
    modal.classList.add('active');
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  };

  window.closeVideoModal = function () {
    var modal = document.getElementById('videoModal');
    if (!modal) return;
    modal.classList.remove('active');
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    var holder = modal.querySelector('.video-modal-content .aspect-video') || modal.querySelector('.video-modal-content');
    if (holder && window.MINDIFY_CASE_VIDEOS) holder.innerHTML = '<div class="flex items-center justify-center h-full"><p class="text-lg opacity-70">Video playback will be integrated here</p></div>';
  };
});

function initMindifyChrome(root) {
  document.querySelectorAll('[id="menu-btn"]').forEach(function (btn) {
    if (btn.dataset.mindifyBound === 'true') return;
    btn.dataset.mindifyBound = 'true';
    btn.addEventListener('click', function (event) {
      event.preventDefault();
      event.stopImmediatePropagation();
      var menu = document.getElementById('mobile-menu');
      if (!menu) return;
      var willOpen = menu.classList.contains('hidden');
      menu.classList.toggle('hidden', !willOpen);
      btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
    }, true);
  });

  document.querySelectorAll('#mobile-menu a').forEach(function (link) {
    if (link.dataset.mindifyMenuBound === 'true') return;
    link.dataset.mindifyMenuBound = 'true';
    link.addEventListener('click', function () {
      var menu = document.getElementById('mobile-menu');
      if (menu) menu.classList.add('hidden');
    });
  });

  var navbar = document.getElementById('navbar');
  if (navbar && !window.mindifyNavbarBound) {
    window.mindifyNavbarBound = true;
    var setScrolled = function () {
      navbar.classList.toggle('nav-scrolled', window.scrollY > 20);
    };
    setScrolled();
    window.addEventListener('scroll', setScrolled, { passive: true });
  }
}

function initMindifyFaq(root) {
  root.querySelectorAll('.faq-btn').forEach(function (btn) {
    if (btn.dataset.mindifyBound === 'true') return;
    btn.dataset.mindifyBound = 'true';
    btn.addEventListener('click', function () {
      var answer = btn.nextElementSibling;
      var icon = btn.querySelector('.faq-icon');
      if (!answer) return;
      var isOpen = answer.classList.contains('open');
      var scope = btn.closest('.mindify-page-part') || document;
      scope.querySelectorAll('.faq-answer').forEach(function (item) {
        item.classList.remove('open');
      });
      scope.querySelectorAll('.faq-icon').forEach(function (item) {
        item.classList.remove('rotated');
      });
      if (!isOpen) {
        answer.classList.add('open');
        if (icon) icon.classList.add('rotated');
      }
    });
  });
}

function initMindifyAppTabs(root) {
  root.querySelectorAll('.app-tab-btn').forEach(function (btn) {
    if (btn.dataset.mindifyBound === 'true') return;
    btn.dataset.mindifyBound = 'true';
    btn.addEventListener('click', function () {
      var section = btn.closest('.mindify-page-part') || document;
      section.querySelectorAll('.app-tab-btn').forEach(function (item) {
        item.style.background = 'transparent';
        item.style.color = '#374151';
        item.style.border = '1px solid #e5e7eb';
      });
      btn.style.background = 'linear-gradient(135deg, #6C47FF, #8B6FFF)';
      btn.style.color = 'white';
      btn.style.border = 'none';

      var tab = btn.dataset.app;
      section.querySelectorAll('.app-panel').forEach(function (panel) {
        panel.classList.add('hidden');
      });
      var activePanel = section.querySelector('[data-panel="' + tab + '"]');
      if (activePanel) activePanel.classList.remove('hidden');
    });
  });
}

function initMindifyHoverVideos(root) {
  root.querySelectorAll('.mindify-hover-video').forEach(function (card) {
    if (card.dataset.mindifyVideoBound === 'true') return;
    var video = card.querySelector('video');
    if (!video) return;
    card.dataset.mindifyVideoBound = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = 'metadata';

    var startVideo = function () {
      try {
        if (video.readyState === 0) video.load();
        video.currentTime = 0;
      } catch (error) {}
      var playPromise = video.play();
      card.classList.add('is-playing');
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function () {
          card.classList.remove('is-playing');
        });
      }
    };

    var stopVideo = function () {
      video.pause();
      try { video.currentTime = 0; } catch (error) {}
      card.classList.remove('is-playing');
    };

    card.addEventListener('mouseenter', function () {
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
      startVideo();
    });

    card.addEventListener('mouseleave', function () {
      if (window.matchMedia && window.matchMedia('(hover: none)').matches) return;
      stopVideo();
    });

    card.addEventListener('click', function (event) {
      if (!(window.matchMedia && window.matchMedia('(hover: none)').matches) && window.innerWidth >= 768) return;
      event.preventDefault();
      if (video.paused) startVideo();
      else stopVideo();
    });
  });
}

document.addEventListener('shopify:section:load', function (event) {
  initMindifyChrome(event.target);
  initMindifyFaq(event.target);
  initMindifyAppTabs(event.target);
  initMindifyHoverVideos(event.target);
  initMindifySmartVideos(event.target);
  initMindifyDeferredVideos(event.target);
  initMindifyHomeCaseShowcases(event.target);
  initMindifyContactForms(event.target);
  initMindifyCookieBanner();
  initMindifyAos(true);
});

function initMindifyContactForms(root) {
  root.querySelectorAll('form[action*="/contact"]').forEach(function (form) {
    if (form.dataset.mindifyContactBound === 'true') return;
    form.dataset.mindifyContactBound = 'true';

    form.addEventListener('submit', function () {
      if (!form.checkValidity()) return;
      var button = form.querySelector('button[type="submit"]');
      if (!button) return;
      var submittingLabel = button.getAttribute('data-submitting-label') || 'Sending...';
      button.dataset.originalHtml = button.innerHTML;
      button.innerHTML = submittingLabel;
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('opacity-70');
    });
  });
}

function initMindifyAos(refreshOnly) {
  if (window.matchMedia && window.matchMedia('(max-width: 767px)').matches) return;
  var start = function () {
    if (window.AOS) {
      if (refreshOnly && typeof AOS.refreshHard === 'function') AOS.refreshHard();
      else AOS.init({ duration: 700, once: true, offset: 80 });
      return;
    }
    if (refreshOnly || document.querySelector('script[data-mindify-aos]')) return;
    var script = document.createElement('script');
    script.src = 'https://unpkg.com/aos@2.3.4/dist/aos.js';
    script.defer = true;
    script.dataset.mindifyAos = 'true';
    script.onload = function () {
      if (window.AOS) AOS.init({ duration: 700, once: true, offset: 80 });
    };
    document.body.appendChild(script);
  };
  var idle = window.requestIdleCallback || function (callback) { window.setTimeout(callback, 1200); };
  if (document.readyState === 'complete') idle(start);
  else window.addEventListener('load', function () { idle(start); }, { once: true });
}

function initMindifyHomeCaseShowcases(root) {
  root.querySelectorAll('[data-home-case-showcase]').forEach(function (showcase) {
    if (showcase.dataset.mindifyCaseShowcaseBound === 'true') return;
    var track = showcase.querySelector('[data-home-case-track]') || showcase;
    var dots = Array.prototype.slice.call(showcase.querySelectorAll('[data-home-case-dot]'));
    var realSlides = Array.prototype.slice.call(showcase.querySelectorAll('[data-home-case-slide]:not([data-home-case-clone])'));
    if (!realSlides.length) return;

    if (realSlides.length > 1 && track.dataset.mindifyLoopCloned !== 'true') {
      var firstClone = realSlides[0].cloneNode(true);
      var lastClone = realSlides[realSlides.length - 1].cloneNode(true);
      firstClone.dataset.homeCaseClone = 'true';
      lastClone.dataset.homeCaseClone = 'true';
      firstClone.setAttribute('aria-hidden', 'true');
      lastClone.setAttribute('aria-hidden', 'true');
      track.insertBefore(lastClone, realSlides[0]);
      track.appendChild(firstClone);
      track.dataset.mindifyLoopCloned = 'true';
    }

    showcase.dataset.mindifyCaseShowcaseBound = 'true';

    var allSlides = Array.prototype.slice.call(track.querySelectorAll('[data-home-case-slide]'));
    var isInViewport = false;
    var activeSlide = realSlides[0];
    var activeIndex = 0;
    var autoTimer = null;
    var isProgrammaticScroll = false;
    var isMobile = function () {
      return window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
    };
    var shouldAutoplay = function () {
      var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var saveData = navigator.connection && navigator.connection.saveData;
      return !isMobile() && !reduceMotion && !saveData && isInViewport && !document.hidden;
    };
    var getMedia = function (slide) {
      return slide && slide.querySelector('[data-home-case-media]');
    };
    var clearSlide = function (slide, releaseSource) {
      var media = getMedia(slide);
      if (!media) return;
      var current = media.querySelector('video, iframe');
      if (current && current.tagName === 'VIDEO') {
        current.pause();
        if (releaseSource) {
          current.removeAttribute('src');
          try { current.load(); } catch (error) {}
          current.remove();
        }
      } else if (current && current.tagName === 'IFRAME' && releaseSource) {
        current.remove();
      }
      media.classList.remove('is-loading', 'is-playing');
    };
    var prepareSlide = function (slide) {
      var media = getMedia(slide);
      if (!media || media.querySelector('video, iframe')) return;
      var localSrc = slide.getAttribute('data-video-src');
      if (!localSrc) return;
      var video = document.createElement('video');
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.poster = slide.getAttribute('data-poster') || '';
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.src = localSrc;
      media.appendChild(video);
      try { video.load(); } catch (error) {}
    };
    var setActiveSlide = function (slide) {
      activeSlide = slide;
      activeIndex = Math.max(0, realSlides.indexOf(slide));
      allSlides.forEach(function (item) {
        item.classList.toggle('is-active', item === slide);
      });
      dots.forEach(function (dot, index) {
        dot.classList.toggle('is-active', index === activeIndex);
        if (index === activeIndex) dot.setAttribute('aria-current', 'true');
        else dot.removeAttribute('aria-current');
      });
    };
    var playSlide = function (slide, force) {
      if (!slide) return;
      if (!force && !shouldAutoplay()) return;
      var media = getMedia(slide);
      if (!media) return;
      allSlides.forEach(function (item) {
        if (item !== slide) clearSlide(item, true);
      });
      setActiveSlide(slide);
      var localSrc = slide.getAttribute('data-video-src');
      var externalSrc = slide.getAttribute('data-external-src');
      var poster = slide.getAttribute('data-poster');
      var title = slide.getAttribute('data-title') || 'Case video';
      var existing = media.querySelector('video, iframe');
      if (externalSrc) {
        if (!existing || existing.tagName !== 'IFRAME') {
          clearSlide(slide, true);
          media.classList.add('is-loading');
          var iframe = document.createElement('iframe');
          iframe.src = externalSrc;
          iframe.title = title;
          iframe.allow = 'autoplay; encrypted-media; picture-in-picture';
          iframe.allowFullscreen = true;
          iframe.loading = 'lazy';
          iframe.addEventListener('load', function () {
            media.classList.remove('is-loading');
            media.classList.add('is-playing');
          }, { once: true });
          media.appendChild(iframe);
        }
        return;
      }
      if (!localSrc) return;
      var video = existing && existing.tagName === 'VIDEO' ? existing : null;
      if (!video) {
        video = document.createElement('video');
        video.muted = true;
        video.loop = true;
        video.playsInline = true;
        video.preload = 'metadata';
        video.poster = poster || '';
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.src = localSrc;
        video.addEventListener('loadeddata', function () {
          media.classList.remove('is-loading');
        }, { once: true });
        media.appendChild(video);
      }
      media.classList.toggle('is-loading', video.readyState < 2);
      var promise = video.play();
      if (promise && typeof promise.then === 'function') {
        promise.then(function () {
          media.classList.remove('is-loading');
          media.classList.add('is-playing');
        }).catch(function () {
          media.classList.remove('is-loading', 'is-playing');
        });
      } else {
        media.classList.remove('is-loading');
        media.classList.add('is-playing');
      }
    };
    var bestVisibleSlide = function () {
      var viewportCenter = window.innerWidth / 2;
      return realSlides.map(function (slide) {
        var rect = slide.getBoundingClientRect();
        var visiblePixels = Math.min(rect.right, window.innerWidth) - Math.max(rect.left, 0);
        var ratio = rect.width > 0 ? Math.max(0, Math.min(1, visiblePixels / rect.width)) : 0;
        return { slide: slide, score: ratio * 1000 - Math.abs((rect.left + rect.width / 2) - viewportCenter) };
      }).sort(function (a, b) { return b.score - a.score; })[0].slide;
    };
    var updateActive = function () {
      if (shouldAutoplay()) {
        var nextVisible = bestVisibleSlide();
        setActiveSlide(nextVisible);
        playSlide(nextVisible, false);
      } else if (isMobile() && isInViewport) {
        prepareSlide(activeSlide || realSlides[0]);
      }
      if (!isInViewport) allSlides.forEach(function (slide) { clearSlide(slide, true); });
    };
    var jumpToRealIndex = function (index) {
      var slide = realSlides[index];
      if (!slide) return;
      track.style.scrollBehavior = 'auto';
      centerSlide(slide, 'auto');
      window.setTimeout(function () { track.style.scrollBehavior = ''; }, 40);
    };
    var centerSlide = function (slide, behavior) {
      var trackRect = track.getBoundingClientRect();
      var slideRect = slide.getBoundingClientRect();
      var delta = (slideRect.left + slideRect.width / 2) - (trackRect.left + trackRect.width / 2);
      track.scrollTo({ left: track.scrollLeft + delta, behavior: behavior || 'smooth' });
    };
    var scrollToIndex = function (index) {
      if (!realSlides.length) return;
      activeIndex = ((index % realSlides.length) + realSlides.length) % realSlides.length;
      var slide = realSlides[activeIndex];
      setActiveSlide(slide);
      isProgrammaticScroll = true;
      centerSlide(slide, 'smooth');
      window.setTimeout(function () { isProgrammaticScroll = false; }, 700);
      playSlide(slide, false);
    };
    var stopAuto = function () {
      if (autoTimer) window.clearInterval(autoTimer);
      autoTimer = null;
    };
    var startAuto = function () {
      stopAuto();
      if (!shouldAutoplay() || realSlides.length < 2) return;
      autoTimer = window.setInterval(function () {
        if (!shouldAutoplay()) {
          stopAuto();
          return;
        }
        if (activeIndex + 1 >= realSlides.length) {
          var firstClone = track.lastElementChild;
          if (firstClone && firstClone.dataset.homeCaseClone === 'true') {
            isProgrammaticScroll = true;
            centerSlide(firstClone, 'smooth');
            window.setTimeout(function () {
              jumpToRealIndex(0);
              isProgrammaticScroll = false;
              setActiveSlide(realSlides[0]);
              playSlide(realSlides[0], false);
            }, 760);
            return;
          }
        }
        scrollToIndex(activeIndex + 1);
      }, 5000);
    };
    dots.forEach(function (dot, index) {
      dot.addEventListener('click', function () {
        stopAuto();
        scrollToIndex(index);
        startAuto();
      });
    });
    allSlides.forEach(function (slide) {
      var playButton = slide.querySelector('[data-home-case-play]');
      if (playButton) {
        playButton.addEventListener('click', function (event) {
          event.preventDefault();
          prepareSlide(slide);
          playSlide(slide, true);
        });
      }
    });
    track.addEventListener('scroll', function () {
      if (isProgrammaticScroll) return;
      window.clearTimeout(showcase._mindifyCaseScrollTimer);
      showcase._mindifyCaseScrollTimer = window.setTimeout(function () {
        updateActive();
        startAuto();
      }, 180);
    }, { passive: true });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          isInViewport = entry.isIntersecting && entry.intersectionRatio >= 0.25;
        });
        updateActive();
        if (isInViewport) startAuto();
        else stopAuto();
      }, { threshold: [0, 0.25, 0.55], rootMargin: '120px 0px' });
      observer.observe(showcase);
    } else {
      isInViewport = true;
      updateActive();
      startAuto();
    }

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        stopAuto();
        allSlides.forEach(function (slide) { clearSlide(slide, false); });
      } else if (shouldAutoplay()) {
        playSlide(activeSlide || bestVisibleSlide(), false);
        startAuto();
      }
    });

    setActiveSlide(realSlides[0]);
    if (realSlides.length > 1) jumpToRealIndex(0);
  });
}

function initMindifySmartVideos(root) {
  var videos = Array.prototype.slice.call(root.querySelectorAll('.mindify-smart-video'));
  if (!videos.length) return;

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;

  videos.forEach(function (video) {
    if (video.dataset.mindifySmartBound === 'true') return;
    video.dataset.mindifySmartBound = 'true';
    video.muted = true;
    video.loop = true;
    video.playsInline = true;
    video.preload = saveData ? 'none' : (video.preload === 'auto' ? 'metadata' : video.preload || 'metadata');
    video.removeAttribute('autoplay');

    if (isMobile) {
      video.preload = 'none';
      video.controls = true;
      var manualPlay = function () {
        loadMindifyVideoSource(video);
        var playPromise = video.paused ? video.play() : null;
        if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function () {});
      };
      video.addEventListener('click', manualPlay);
      video.addEventListener('pointerdown', manualPlay, { passive: true });
      var smartVideoShell = video.closest('.mindify-what-video');
      if (smartVideoShell && smartVideoShell.dataset.mindifySmartClickBound !== 'true') {
        smartVideoShell.dataset.mindifySmartClickBound = 'true';
        smartVideoShell.addEventListener('click', manualPlay);
      }
    }
  });

  if (isMobile || prefersReducedMotion || saveData || !('IntersectionObserver' in window)) return;

  var observer = window.mindifySmartVideoObserver;
  if (!observer) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting && entry.intersectionRatio >= 0.45) {
          loadMindifyVideoSource(video);
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(function () {});
          }
        } else {
          video.pause();
        }
      });
    }, { threshold: [0, 0.45, 0.75], rootMargin: '120px 0px' });
    window.mindifySmartVideoObserver = observer;
  }

  videos.forEach(function (video) {
    observer.observe(video);
  });
}

function initMindifyDeferredVideos(root) {
  var videos = Array.prototype.slice.call(root.querySelectorAll('.mindify-deferred-video'));
  if (!videos.length) return;

  var registry = window.mindifyDeferredVideoRegistry;
  if (!registry) {
    registry = {
      items: new Map(),
      active: new Set(),
      raf: null
    };
    window.mindifyDeferredVideoRegistry = registry;
  }

  var prefersReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;
  var isMobile = window.matchMedia && window.matchMedia('(max-width: 767px)').matches;
  var maxActive = 1;

  var updateShell = function (media, state) {
    var shell = media.closest('.mindify-case-inline-video');
    if (!shell) return;
    shell.classList.toggle('is-loading', state === 'loading');
    shell.classList.toggle('has-playing-video', state === 'playing' || state === 'loaded');
    shell.classList.toggle('is-idle', state === 'idle');
  };

  var loadDeferred = function (media, shouldPlay) {
    if (!media) return;

    if (media.tagName === 'IFRAME') {
      if (media.dataset.mindifyLoaded === 'true' && media.src) {
        updateShell(media, 'playing');
        return;
      }
      updateShell(media, 'loading');
      if (!media.src && media.dataset.src) media.src = media.dataset.src;
      media.addEventListener('load', function () {
        media.dataset.mindifyLoaded = 'true';
        updateShell(media, 'playing');
      }, { once: true });
      return;
    }

    if (media.tagName === 'VIDEO') {
      updateShell(media, media.readyState >= 2 ? 'loaded' : 'loading');
      media.muted = true;
      media.loop = true;
      media.playsInline = true;
      media.preload = 'metadata';
      if (!media.currentSrc && !media.src && media.dataset.src) {
        media.src = media.dataset.src;
        media.load();
      }
      if (!shouldPlay || prefersReducedMotion || saveData) {
        updateShell(media, 'loaded');
        return;
      }
      var promise = media.play();
      if (promise && typeof promise.then === 'function') {
        promise.then(function () {
          updateShell(media, 'playing');
        }).catch(function () {
          updateShell(media, 'loaded');
        });
      } else {
        updateShell(media, 'playing');
      }
    }
  };

  var releaseDeferred = function (media, releaseSource) {
    if (!media) return;
    if (media.tagName === 'VIDEO') {
      media.pause();
      if (releaseSource && media.src) {
        media.removeAttribute('src');
        try { media.load(); } catch (error) {}
      }
    } else if (media.tagName === 'IFRAME' && releaseSource && media.src) {
      media.removeAttribute('src');
      media.dataset.mindifyLoaded = 'false';
    }
    updateShell(media, 'idle');
  };

  var scheduleActiveUpdate = function () {
    if (registry.raf) return;
    registry.raf = window.requestAnimationFrame(function () {
      registry.raf = null;
      var viewportCenter = window.innerHeight / 2;
      var preloadMargin = isMobile ? 80 : 140;
      var candidates = Array.prototype.slice.call(registry.items.entries())
        .map(function (entry) {
          var media = entry[0];
          var meta = entry[1];
          var rect = media.getBoundingClientRect();
          var visiblePixels = Math.min(rect.bottom, window.innerHeight) - Math.max(rect.top, 0);
          var actualRatio = rect.height > 0 ? Math.max(0, Math.min(1, visiblePixels / rect.height)) : 0;
          var nearViewport = rect.bottom > -preloadMargin && rect.top < window.innerHeight + preloadMargin;
          meta.visible = nearViewport && actualRatio >= 0.12;
          meta.ratio = Math.max(meta.ratio || 0, actualRatio);
          registry.items.set(media, meta);
          if (!meta.visible) return null;
          var mediaCenter = rect.top + rect.height / 2;
          return {
            media: media,
            score: meta.ratio * 1000 - Math.abs(mediaCenter - viewportCenter)
          };
        })
        .filter(Boolean)
        .sort(function (a, b) { return b.score - a.score; });

      var nextActive = new Set(candidates.slice(0, maxActive).map(function (item) { return item.media; }));

      registry.items.forEach(function (meta, media) {
        if (nextActive.has(media)) {
          loadDeferred(media, true);
        } else {
          var rect = media.getBoundingClientRect();
          var farFromViewport = rect.bottom < -160 || rect.top > window.innerHeight + 320;
          releaseDeferred(media, farFromViewport);
        }
      });

      registry.active = nextActive;
    });
  };

  if (!('IntersectionObserver' in window)) {
    videos.slice(0, maxActive).forEach(function (media) {
      loadDeferred(media, !isMobile);
    });
    return;
  }

  var observer = window.mindifyDeferredVideoObserver;
  if (!observer) {
    observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var media = entry.target;
        var meta = registry.items.get(media) || {};
        meta.visible = entry.isIntersecting && entry.intersectionRatio >= 0.18;
        meta.ratio = entry.intersectionRatio || 0;
        registry.items.set(media, meta);
      });
      scheduleActiveUpdate();
    }, { threshold: [0, 0.18, 0.45, 0.72], rootMargin: (isMobile ? '80px 0px' : '140px 0px') });
    window.mindifyDeferredVideoObserver = observer;

    window.addEventListener('scroll', scheduleActiveUpdate, { passive: true });
    window.addEventListener('resize', scheduleActiveUpdate, { passive: true });
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        registry.items.forEach(function (meta, media) {
          releaseDeferred(media, false);
        });
      } else {
        scheduleActiveUpdate();
      }
    });
  }

  videos.forEach(function (media) {
    if (media.dataset.mindifyDeferredBound === 'true') return;
    media.dataset.mindifyDeferredBound = 'true';
    registry.items.set(media, { visible: false, ratio: 0 });
    updateShell(media, 'idle');
    observer.observe(media);
  });
}

function loadMindifyVideoSource(video) {
  if (!video || video.currentSrc || video.src) return;
  var src = video.getAttribute('data-src');
  if (!src) return;
  video.src = src;
  video.load();
}

function initMindifyCookieBanner() {
  var translate = function () {
    var banner = document.getElementById('shopify-pc__banner');
    if (!banner || banner.dataset.mindifyTranslated === 'true') return;

    var title = banner.querySelector('#shopify-pc__banner__body-title');
    if (title) title.textContent = 'Cookie consent';

    var body = banner.querySelector('.shopify-pc__banner__body p');
    if (body) {
      var policy = body.querySelector('a');
      body.textContent = 'We and our partners, including Shopify, use cookies and similar technologies to provide a personalized experience, show relevant ads, and understand site performance. We only use these technologies for these purposes with your consent. ';
      if (policy) {
        policy.textContent = 'Privacy Policy';
        body.appendChild(policy);
      }
    }

    banner.querySelectorAll('button, a').forEach(function (item) {
      var text = (item.textContent || '').trim();
      if (text === '\u7ba1\u7406\u504f\u597d\u8bbe\u7f6e') item.textContent = 'Manage preferences';
      if (text === '\u63a5\u53d7') item.textContent = 'Accept';
      if (text === '\u62d2\u7edd') item.textContent = 'Decline';
      if (text === '\u9690\u79c1\u653f\u7b56') item.textContent = 'Privacy Policy';
    });

    banner.dataset.mindifyTranslated = 'true';
  };

  translate();
  if (window.mindifyCookieObserver) return;
  window.mindifyCookieObserver = new MutationObserver(translate);
  window.mindifyCookieObserver.observe(document.documentElement, { childList: true, subtree: true });
}

function getMindifyEmbedUrl(data) {
  if (!data) return '';
  if (data.externalVideoId && data.externalVideoType === 'youtube') {
    return 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(data.externalVideoId) + '?autoplay=1&mute=1&rel=0&playsinline=1';
  }
  if (data.externalVideoId && data.externalVideoType === 'vimeo') {
    return 'https://player.vimeo.com/video/' + encodeURIComponent(data.externalVideoId) + '?autoplay=1&muted=1';
  }
  if (data.videoUrl && /youtube\.com|youtu\.be|vimeo\.com/.test(data.videoUrl)) return data.videoUrl;
  return '';
}

function escapeMindifyAttr(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}
